import { nanoid } from 'nanoid'

export default {
  inject: {
    context: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      valueBackup: null
    }
  },
  props: {
    visibility: {
      type: Object,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    help: {
      type: String,
      default: null
    },
    isVisible: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      default: null
    },
    v: {
      type: Object,
      default: () => ({})
    },
    showEditButton: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isOnEditMode () {
      return !!this.$route?.params?.id
    },
    isRequired () {
      return this.v.required !== undefined
    },
    id () {
      return this.$attrs?.id || nanoid(10)
    },

    validation () {
      if (!Object.keys(this.v).length) {
        return { hasError: false }
      }
      return {
        hasError: '$error' in this.v ? this.v.$error : undefined,
        required: 'required' in this.v ? this.v.required : undefined,
        maxLength: 'maxLength' in this.v ? this.v.maxLength : undefined,
        minLength: 'minLength' in this.v ? this.v.minLength : undefined,
        sameAs: 'sameAs' in this.v ? this.v.sameAs : undefined
      }
    },

    showValidationErrorMessage () {
      if (this.validation.required === false) {
        return this.$t('field_required')
      }
      if (this.validation.maxLength === false) {
        return this.$tc('character_max_length', this.v.$params.maxLength.max)
      }
      if (this.validation.minLength === false) {
        return this.$tc('character_min_length', this.v.$params.minLength.min)
      }
      if (this.validation.sameAs === false) {
        return this.$t('field_same_as') + this.labelOfFieldUsedForsameAsValidation
      }
      return null
    },

    showComponent () {
      if (this.visibility?.isActive && this.visibility?.conditions?.length && this.context) {
        let show = true
        for (const condition of this.visibility.conditions) {
          show = this.processCondition(this.context[condition.leftValueToCompare], condition.comparation, condition.rightValueToCompare)
          if (!show) break
        }
        return show
      }
      return true
    }
  },
  watch: {
    // Si el componente deja de mostrarse, su valor vuelve a "null"
    // Guardo su valor en un backup por si se vuelve a mostrar
    showComponent (val) {
      if (!val) {
        this.valueBackup = this.value
        this.$emit('input', null)
      } else {
        if (this.valueBackup) {
          this.$emit('input', this.valueBackup)
        }
      }
    }
  },
  methods: {
    processCondition (leftVal, comparation, rightVal) {
      let show
      if (typeof leftVal === 'boolean') {
        leftVal = String(leftVal)
      }
      if (typeof rightVal === 'boolean') {
        leftVal = String(leftVal)
      }
      leftVal = leftVal?.id || leftVal?.name || leftVal
      rightVal = rightVal?.id || rightVal?.name || rightVal
      switch (comparation) {
        case '===':
          show = leftVal === rightVal
          break
        case '!==':
          show = leftVal !== rightVal
          break
        case '>':
          show = leftVal > rightVal
          break
        case '>=':
          show = leftVal >= rightVal
          break
        case '<':
          show = leftVal < rightVal
          break
        case '<=':
          show = leftVal <= rightVal
          break
      }
      return show
    }
  }
}
